import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DispatchLoadPromotions,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import { getCurrentPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, PopulateApiParameter, props => {
    const pageType = getCurrentPage(props.getState()).type;
    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        expand: ["shipping", "allowintegration"] as GetCartApiParameter["expand"],
    };

    if (!getSession(props.getState()).rememberMe) {
        props.apiParameter.expand?.push("validation");
    }

    const currentTime = Date.now();

    if (props.needFullCart) {
        props.apiParameter.forceRecalculation = true;
        props.apiParameter.allowInvalidAddress = true;
        props.apiParameter.expand = [
            ...(props.apiParameter.expand || []),
            "cartLines",
            "restrictions",
            "tax",
            "carriers",
            "paymentOptions",
            "costCodes",
            `${currentTime}`,
        ] as GetCartApiParameter["expand"];

        if (pageType === "CartPage") {
            const isClearingCart = props.getState().pages.cart.isClearingCart;
            props.apiParameter.expand?.push("hiddenproducts");
            if (
                isClearingCart &&
                props.apiParameter.expand &&
                props.apiParameter.expand.length > 0 &&
                props.apiParameter.expand.indexOf("carriers") > -1
            ) {
                props.apiParameter.expand = props.apiParameter.expand?.filter(element => {
                    return element !== "carriers" && element !== `${currentTime}`;
                });
            }
        }
        if (pageType === "CheckoutReviewAndSubmitPage") {
            if (props.apiParameter.expand) {
                const itemsToRemove: (
                    | "tax"
                    | "shipping"
                    | "paymentOptions"
                    | "carriers"
                    | "validation"
                    | "cartLines"
                    | "restrictions"
                    | "costCodes"
                )[] = ["restrictions"];
                for (const item of itemsToRemove) {
                    const index = props.apiParameter.expand.indexOf(item);
                    if (index > -1) {
                        props.apiParameter.expand.splice(index, 1);
                    }
                }
            }
        }
    }

    if (props.parameter.getCartLines) {
        props.apiParameter.expand?.push("cartLines");
    }

    if (props.parameter.getCostCodes) {
        props.apiParameter.expand?.push("costCodes");
    }
});
replaceInChain(chain, DispatchLoadPromotions, props => {
    const currentPromotionsState = getCurrentPromotionsDataView(props.getState());
    const promotionsNotLoaded = !currentPromotionsState.value && !currentPromotionsState.isLoading;
    if (
        props.parameter.getPromotions ||
        props.parameter.shouldLoadFullCart ||
        (props.needFullCart && promotionsNotLoaded)
    ) {
        props.dispatch(loadCurrentPromotions());
    }
});
